import request, { download } from "@/utils/request";


export function getSalesAgainVisitListSchool (data) {
  return request({
    url: `/report/schoolStudentVisitConfig/getSalesAgainVisitListSchool`,
    method: 'post',
    data
  })
}

export function getSalesAgainVisitListEmployee (data) {
  return request({
    url: `/report/schoolStudentVisitConfig/getSalesAgainVisitListEmployee`,
    method: 'post',
    data
  })
}



export function exportSalesAgainVisitListSchool (query) {
  return download(
    `/report/schoolStudentVisitConfig/exportSalesAgainVisitListSchool`,
    { ...query },
    `销售回访情况校区_${new Date().getTime()}.xlsx`,
    { headers: { 'Content-Type': 'application/json' }, }
  );
}



export function exportSalesAgainVisitListEmployee (query) {
  return download(
    `/report/schoolStudentVisitConfig/exportSalesAgainVisitListEmployee`,
    { ...query },
    `销售回访情况员工_${new Date().getTime()}.xlsx`,
    { headers: { 'Content-Type': 'application/json' }, }
  );
}


export function setPreLockTime (data) {
  return request({
    url: `/system/saleScheduleConfig/setPreLockTime`,
    method: 'post',
    data
  })
}

export function unLockTimeApi (data) {
  return request({
    url: `/system/saleScheduleConfig/unLockTime`,
    method: 'post',
    data
  })
}

export function fillSaleAimApi (data) {
  return request({
    url: `/system/saleScheduleConfig/fillSaleAim`,
    method: 'post',
    data
  })
}
export function fillSaleAimSchool (campusId) {
  return request({
    url: `/report/schoolStudentVisitConfig/campus/goal/${campusId}`,
    method: 'get',
  })
}
export function getLockRecordsApi (params) {
  return request({
    url: `/system/saleScheduleConfig/getLockRecords`,
    method: 'get',
    params
  })
}


/** 面访统计表 */
export function getVisitList (data) {
  return request({
    url: '/report/visit/count/getList',
    method: 'post',
    headers: { repeatSubmit: false },
    data
  })
}


/**回访录音交流 */

//获取表格数据
export function getSoundRecording (data, page) {
  return request({
    url: '/system/soundRecordingController/list',
    method: 'post',
    headers: { repeatSubmit: false },
    data,
    params: page
  })
}


//点赞
export function giveThumbsUp (data) {
  return request({
    url: '/system/soundRecordingController/addUp',
    method: 'post',
    headers: { repeatSubmit: false },
    data
  })
}

//评价
export function addEvaluate (data) {
  return request({
    url: '/system/soundRecordingController/addEvaluate',
    method: 'post',
    headers: { repeatSubmit: false },
    data
  })
}


//查询评价表
export function getEvaluateList (data, page) {
  return request({
    url: '/system/soundRecordingController/detailsList',
    method: 'post',
    data,
    params: page
  })
}


//打点
export function addLook (data) {
  return request({
    url: '/system/soundRecordingController/addLook',
    method: 'post',
    data
  })
}

//查询播放次数表
export function getLookList (data, page) {
  return request({
    url: '/system/soundRecordingController/lookList',
    method: 'post',
    data,
    params: page
  })
}


//是否有查看权限，返回学员类型
export function checkRole (data) {
  return request({
    url: '/system/soundRecordingController/isRole',
    method: 'post',
    data
  })
}

//获取某个校区销售目标分解详情接口
export function saleGoalSchoolDetail (params) {
  return request({
    url: '/contract/saleGoal/operate/school/detail',
    method: 'get',
    params
  })
}

//保存校区销售目标分解详情接口
export function saveSaleGoalSchool (data) {
  return request({
    url: '/contract/saleGoal/operate/school/allocate',
    method: 'post',
    data
  })
}


//获取个人销售目标
export function personalSaleGoal (params) {
  return request({
    url: '/contract/saleGoal/operate/personal/detail',
    method: 'get',
    params
  })
}

//确认个人销售目标数据接口
export function confirmPersonalSaleGoal (params) {
  return request({
    url: '/contract/saleGoal/operate/personal/confirm',
    method: 'post',
    params
  })
}

//获取校区分解目标时间
export function schoolSaleGoalDealine (params) {
    return request({
        url: '/contract/saleGoal/operate/school/deadline/list',
        method: 'get',
        params
    })
}

//取个人确认目标时间接口
export function personalSaleGoalDealine (params) {
    return request({
        url: '/contract/saleGoal/operate/personal/deadline/list',
        method: 'get',
        params
    })
}
